/** @format */

export interface BreadCrumbResponse {
  breadcrumbList: Breadcrumb[];
}

export interface Breadcrumb {
  categoryId: number;
  name: string;
  url?: string;
  note?: string;
}
